import { render } from "./AllCharts.vue?vue&type=template&id=71850d14"
import script from "./AllCharts.vue?vue&type=script&lang=js"
export * from "./AllCharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__